var prodcat = prodcat || {};

prodcat.ui = prodcat.ui || {};
prodcat.data = prodcat.data || {};
(function ($) {
  /**
   * auto replenish
   */
  Drupal.behaviors.sppAutoReplenishV1 = {
    attach: function (context) {
      var $template = $('.spp-autoreplenish-v1', context);
      var $product = $template.closest('.js-product-ui');
      var $replenishDropdown = $('.js-replenishment-select', $template);
      var $addToBag = $product.find('.js-product-add-to-bag');

      $replenishDropdown.on('change', function () {
        $addToBag.attr('data-replenishment', this.value);
      });
    }
  };

  // Clear and re-check replenishment wrapper on sku change.
  $(document).on('product.skuSelect', '.js-product-ui', function (e, skuBaseId) {
    var $product = $(this);
    var skuData = prodcat.data.getSku(skuBaseId);
    var $replenishWrapper = $('.product-full__sku-extras', $product);
    var $replenishDropdown = $('.js-replenishment-select', $replenishWrapper);
    var $addToBag = $product.find('.js-product-add-to-bag');

    $addToBag.attr('data-replenishment', '');
    $replenishDropdown.val(null).trigger('change');
    if (skuData && !skuData.REFILLABLE || Drupal.settings.globals_variables && !Drupal.settings.globals_variables.enable_auto_replenish_spp) {
      $replenishWrapper.removeClass('product-full__sku-extras--has-replenishment');
    } else {
      // avoid to add double class in the replenishWrapper element
      if (!$replenishWrapper.hasClass('product-full__sku-extras--has-replenishment')) {
        $replenishWrapper.addClass('product-full__sku-extras--has-replenishment');
      }
    }
  });
})(jQuery);
